import getColor from "@insite/mobius/utilities/getColor";
import Styleguide from "@store/Framework/Types/Styleguide";
import {
    formFieldDescriptionWrapperVariantStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldLabelStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
import { css } from "styled-components";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/FormField ------------------------------------ */
/* ------------------------------------------------------------------------------------------ */

const formField: Styleguide["formField"] = {
    defaultProps: {
        border: "rounded",
        backgroundColor: "common.background",
        labelProps: {
            css: formFieldLabelStyles(),
        },
        errorProps: {
            color: "danger",
            size: "inherit",
            weight: "inherit",
        },
        hintProps: {
            color: "info",
            size: "inherit",
            weight: "inherit",
        },
        cssOverrides: {
            inputSelect: css`
                ${formFieldVariantStyles()}
                ${formFieldInputSelectIconStyles("primary", "primary.dark")}
                ${formFieldInputSelectDisabledStyles("text.disabled", "common.disabled")}
                color: ${getColor("text.input")};
            `,
            descriptionWrapper: css`
                ${formFieldDescriptionWrapperVariantStyles()}
                font-weight: ${x => x.theme.design.typography.weight.bold};
            `,
        },
    },
};

export default formField;
